import React from 'react';

function CustomCardBody({ children, className }) {
  return <div className={`card-block ${className || ''} `}>{children}</div>;
}

export default CustomCardBody;



// WEBPACK FOOTER //
// ./src/Components-2025/QuestionBank/CustomCardBody.jsx